// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";

import { Link } from "react-router-dom";

import Storage from "core/Storage";
import { Icon } from "kit/ui";
import { VARS } from "styles-js";
import { Container } from "kit/grid";

import CustomerContext from "../../contexts/CustomerContext";

import STORAGE from "../../constants/STORAGE";
import ROUTES_BASED_ON_CUSTOMER_STATUS from "../../constants/ROUTES_BASED_ON_CUSTOMER_STATUS";

import Loader from "../../kit/ui/Button/Button.Loader";
import routesObject from "../../routesObject";

import * as styles from "./Header.styles";

import logo from "../../assets/img/mykredit-es.svg";



interface HeaderProps {
  isMobileMenuVisible: boolean;
  initInProgress: boolean;
  handleToggleMobileMenuVisibility: () => void;
  handleUserLogout: () => void;
}

function Header({
  isMobileMenuVisible,
  initInProgress,
  handleToggleMobileMenuVisibility,
  handleUserLogout
}: HeaderProps) {

  const [ prevScroll, setPrevScroll ] = useState<null | number>(null);
  const [ headerVisible, setHeaderVisible ] = useState<boolean>(true);

  const customerDetails = useContext(CustomerContext);

  const routesBasedOnCustomerStatus = ROUTES_BASED_ON_CUSTOMER_STATUS();

  useEffect(() => {
    const scrollListener = _.throttle(() => {
      const isDirectionDown = window.scrollY > prevScroll;
      const headerVisibility = window.scrollY < VARS.headerHeight || !isDirectionDown || !prevScroll || (prevScroll && !isDirectionDown);
      setPrevScroll(scrollY);
      setHeaderVisible(headerVisibility);
    }, 50, {
      leading: true,
      trailing: true
    });

    window.addEventListener("scroll", scrollListener);

    return () => {
      window.removeEventListener("scroll", scrollListener);
    };
  }, [ prevScroll ]);

  const toggleMobileMenu = () => handleToggleMobileMenuVisibility(!isMobileMenuVisible);

  return (
    <div
      id="header"
      css={[
        styles.base,
        {
          height: `${VARS.headerHeight}px`
        }
      ]}>
      <div css={[
        styles.wrapper,
        !headerVisible && styles.hidden
      ]}>

        <Container>

          <div css={styles.inner}>

            <div css={styles.logoHolder}>
              <Link to={routesObject.home.url}>
                <img css={styles.logo} src={logo} alt="Mykredit Logo" />
              </Link>
            </div>

            <div css={styles.navHolder}>
              <ul>
                <li><Link to={routesObject.aboutUs.url}>Sobre myKredit</Link></li>
                <li><Link to={routesObject.contactUs.url}>Contacto</Link></li>
                {
                  !!customerDetails && (
                    <li>
                      <Link
                        className="accountLink"
                        to={routesObject.account.url}>
                        Gestión de la Cuenta
                      </Link>
                    </li>
                  )
                }
              </ul>
            </div>

            <>
              {initInProgress && (
                <a id="profile-btn" css={styles.loginBtn}>
                  <Loader loading style={styles.loadingStyles} />
                </a>
              )}
              {!initInProgress && (
                <>
                  <Link
                    id="profile-btn"
                    to={customerDetails ? Storage.Local.get(STORAGE.loanFlowIdFromLoanApply + customerDetails.id) ? routesObject.loanApply.url : routesBasedOnCustomerStatus[customerDetails.status] : routesObject.login.url}
                    css={[
                      styles.loginBtn,
                      !!customerDetails && styles.userLoggedInName
                    ]}>
                    <>
                      <Icon size="20" name="myk user" />
                      {customerDetails ?
                        (
                          <>
                            <span className="txt short">{customerDetails.twoLetterName}</span>
                            <span className="txt full">{customerDetails.fullName}</span>
                          </>
                        ) :
                        (
                          <span className="txt">Área de Clientes</span>
                        )}
                    </>
                  </Link>

                  {
                    !!customerDetails && (
                      <button
                        onClick={() => handleUserLogout()}
                        css={styles.logoutBtn}>
                        <Icon name="myk logout" />
                      </button>
                    )
                  }
                </>
              )}
            </>

            <div css={styles.mobileTogglerHolder}>
              <button
                onClick={toggleMobileMenu}
                css={[
                  styles.toggler,
                  isMobileMenuVisible && styles.mobileMenuActive
                ]}
                type="button"
                title="Mobile Menu Toggler">
                <span css={styles.togglerBox}>
                  <span css={styles.togglerInner} />
                </span>
              </button>
            </div>

          </div>
        </Container>
      </div>

    </div>
  );
}

export default React.memo(Header);
